import { cubicInOut } from 'svelte/easing';

export const levelSliding = function slide(
  node,
  { delay = 0, duration = 300, easing = cubicInOut }
) {
  const style = getComputedStyle(node);
  const width = parseFloat(style.width);

  return {
    delay,
    duration,
    easing,
    css: t =>
      `margin-left: ${width * (1 - t)}px;`,
  };
};



// WEBPACK FOOTER //
// ./src/commons/navigation/nav-utils.js